import { Action, createReducer, on } from '@ngrx/store';
import { IApproveFICAUpdateResponse, IApproveFICAUpdateRequest } from '../models/approve-fica.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadApproveFICARequest, loadApproveFICAResponse, loadApproveFICAFailure } from '../actions/approve-fica.actions';

export const approveFICAFeatureKey = 'approveFICA';

export interface ApproveFICAState {
  approveFICARequest: IApproveFICAUpdateRequest;
  approveFICAResponse: IApproveFICAUpdateResponse;
  approveFICAFailure: IGenericError<ErrorResponse>;
}

export const initialState: ApproveFICAState = {
  approveFICARequest: undefined,
  approveFICAResponse: undefined,
  approveFICAFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadApproveFICARequest, (state, action) => ({
    ...state,
    approveFICARequest: action.request
  })),
  on(loadApproveFICAResponse, (state, action) => ({
    ...state,
    approveFICAResponse: action.response
  })),
  on(loadApproveFICAFailure, (state, action) => ({
    ...state,
    approveFICAFailure: action.error
  }))
);

export const getApproveFICARequest = (state: ApproveFICAState) => state.approveFICARequest;
export const getApproveFICAResponse = (state: ApproveFICAState) => {
  return state.approveFICAResponse;
};
export const getApproveFICAFailure = (state: ApproveFICAState) => state.approveFICAFailure;
